import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-notification-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfNotificationIconProps {}
/**
 * component used to display not a notification icon
 * @param props - CcfNotificationIconProps
 * @example - <CcfNotificationIcon />
 * @returns SVG of CcfNotification  icon
 */
export function CcfNotificationIcon(props: CcfNotificationIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0.5C11.3137 0.5 14 3.09692 14 6.3004C14 7.97733 13.2546 9.5164 11.7961 10.8943C11.7324 10.9544 11.6831 11.0268 11.6511 11.1065L11.6252 11.1884L10.6891 15.1051C10.5048 15.8763 9.82359 16.435 9.0181 16.4947L8.87476 16.5H7.12549C6.30654 16.5 5.58999 15.9839 5.34865 15.2385L5.31107 15.1046L4.37626 11.1885C4.34955 11.0766 4.29016 10.9744 4.20515 10.8942C2.8153 9.58192 2.07265 8.1235 2.00507 6.53902L2 6.3004L2.00321 6.10893C2.1077 2.99408 4.75256 0.5 8 0.5ZM9.75034 13.6993H6.24883L6.52069 14.8348C6.57912 15.0798 6.78817 15.2606 7.04008 15.2942L7.12549 15.2999H8.87476C9.13487 15.2999 9.36395 15.1437 9.45465 14.9141L9.47956 14.8349L9.75034 13.6993ZM8 1.70008C5.433 1.70008 3.34074 3.66503 3.24481 6.12394L3.24138 6.3004L3.24694 6.52202C3.30995 7.77276 3.90942 8.93748 5.07251 10.0356C5.2911 10.242 5.45323 10.4967 5.54556 10.7767L5.58586 10.9187L5.96248 12.4992H10.0367L10.4156 10.9182C10.4843 10.6306 10.6249 10.3646 10.8241 10.143L10.9285 10.036C12.0909 8.9378 12.6901 7.773 12.7531 6.52206L12.7586 6.3004L12.7551 6.12394C12.6592 3.66503 10.567 1.70008 8 1.70008Z"
          fill="#93A4AA"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfNotificationIcon;
